export const validateDate = (dateString) => {
  // Regex para validar o formato de data dd/MM/yyyy
  const regex1 = /^\d{4}-\d{2}-\d{2}$/; // Formato 'YYYY-MM-DD'
  const regex2 = /^\d{2}\/\d{2}\/\d{4}$/; // Formato 'MM/DD/YYYY'
  const regex3 = /^\d{2}\.\d{2}\.\d{4}$/; // Formato 'MM.DD.YYYY'

  return regex1.test(dateString) || regex2.test(dateString) || regex3.test(dateString);
}

export const formatDate = (dateString) => {
  // Cria um objeto Date a partir da string de data
  const data = new Date(dateString);
  
  const day = String(data.getDate()).padStart(2, '0');
  const month = String(data.getMonth() + 1).padStart(2, '0');
  const year = data.getFullYear();
  
  // Retorna a string de data formatada no formato dd/MM/yyyy
  return `${year}-${month}-${day}`;
}

export const formatDateString = (date, format) => {
  const map = {
    'DD': date.getDate().toString().padStart(2, '0'),
    'dd': date.getDate().toString().padStart(2, '0'),
    'MM': (date.getMonth() + 1).toString().padStart(2, '0'),
    'YYYY': date.getFullYear().toString(),
    'HH': date.getHours().toString().padStart(2, '0'),
    'mm': date.getMinutes().toString().padStart(2, '0'),
    'SS': date.getSeconds().toString().padStart(2, '0')
  };

  return format.replace(/DD|dd|MM|YYYY|HH|mm|SS/g, (matched) => map[matched]).replace(" ", "");
}

export const parseDate = (dateString) => {
  // exemplo: now + 1 day
  let dateStrList = dateString?.split(" ");

  if (dateStrList && ["now", "current_timestamp"].includes(dateStrList[0])) {
    let operation = dateStrList[1];
    let value = parseInt(dateStrList[2]);
    let unit = dateStrList[3];
    let date = new Date();

    if (operation === "+") {
      if (unit === "day") {
        date = addDays(date, value);
      } else if (unit === "month") {
        date = addMonths(date, value);
      } else if (unit === "year") {
        date = addYears(date, value);
      }
    }

    if (operation === "-") {
      if (unit === "day") {
        date = subDays(date, value);
      } else if (unit === "month") {
        date = subMonths(date, value);
      } else if (unit === "year") {
        date = subYears(date, value);
      }
    }

    return formatDateString(date, 'YYYY-MM-dd')
  }

  return dateString
}

export const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const addMonths = (date, months) => {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}

export const addYears = (date, years) => {
  const result = new Date(date);
  result.setFullYear(result.getFullYear() + years);
  return result;
}

export const subDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() - days);
  return result;
}

export const subMonths = (date, months) => { 
  const result = new Date(date);
  result.setMonth(result.getMonth() - months);
  return result;
}

export const subYears = (date, years) => {
  const result = new Date(date);
  result.setFullYear(result.getFullYear() - years);
  return result;
}
